import script from "./AvaliarProva.vue?vue&type=script&setup=true&lang=js"
export * from "./AvaliarProva.vue?vue&type=script&setup=true&lang=js"

import "./AvaliarProva.vue?vue&type=style&index=0&id=1e45f0e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e45f0e0"]])

export default __exports__